/** @format */

import {AccountDesignsOrdersContext} from 'frontier/account/components/context/AccountDesignsOrdersContext';
import {ReorderDesign} from '../../../design_actions/reorder_design';
import {ArchiveDesign} from '../../../design_actions/archive_design';
import {ORDER_STATUS_COMPLETE, PRODUCT_TYPE_GRAPHIC_DESIGN} from 'frontier-constants';
import React, {useContext, useState} from 'react';
import update from 'immutability-helper';
import {createAndClickDownload, If} from 'frontier-utilities';

const Column = ({design}) => {
    const ctx = useContext(AccountDesignsOrdersContext);

    const isNotGraphicDesign = ctx.order.product_type_id !== PRODUCT_TYPE_GRAPHIC_DESIGN;

    return (
        <>
            <If condition={isNotGraphicDesign && ctx.order.status_id === ORDER_STATUS_COMPLETE}>
                <ReorderDesign shouldByPassErrors={ctx.shouldByPassErrors} />
                <div className="mb-2">
                    <ArchiveDesign />
                </div>
            </If>
            <a
                className="p-0 m-0 d-flex align-items-center justify-content-start"
                target={'_blank'}
                href={`/account/designs/download-design?key=${encodeURIComponent(
                    design.pressready_key ?? design.customer_key
                )}&bucket=${[process.env.FILESTACK_ARTWORK_CONTAINER]}`}>
                <i className="fa fa-download me-2" />
                <u>Download</u>
            </a>
        </>
    );
};

export const ActionColumn = props => {
    const shouldByPassErrors = props.shouldByPassErrors;
    const designOrder = props.designOrder;
    const order = props.order;

    const [design, setDesign] = useState(designOrder.design);

    const handleToggleIsArchived = value => {
        const updateTarget = {
            is_archived: {$set: value}
        };
        setDesign(update(design, updateTarget));
    };

    return (
        <AccountDesignsOrdersContext.Provider
            key={designOrder.id}
            value={{
                designs_order: designOrder,
                handleToggleIsArchived,
                shouldByPassErrors,
                size: order.size,
                design,
                order
            }}>
            <Column order={order} design={design} />
        </AccountDesignsOrdersContext.Provider>
    );
};
